import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { BridgeElement } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "action-button"

  connect() {
    super.connect()
    // Don't gate on `enabled`: on Android cold boot Stimulus connects before the native
    // bridge adapter is injected, so `enabled` is still false and the button was dropped.
    // `send` queues until the adapter exists and ignores platforms without action-button.
    if (this.platformOptingOut) return

    const el = new BridgeElement(this.element)
    const title = (el.bridgeAttribute("title") || el.title || "").trim()
    const rawImage = el.bridgeAttribute("ios-image")
    const rawTint = el.bridgeAttribute("tint-color")
    const rawPosition = (el.bridgeAttribute("position") || "right").trim().toLowerCase()
    const rawNativeAction = (el.bridgeAttribute("action") || "link").trim().toLowerCase()
    const hasUnread = el.bridgeAttribute("has-unread") === "true"
    const payload = {}
    if (title) payload.title = title
    if (rawImage != null && String(rawImage).trim() !== "") {
      payload.iosImage = String(rawImage).trim()
    }
    if (rawTint != null && String(rawTint).trim() !== "") {
      payload.tintColor = String(rawTint).trim()
    }
    if (rawPosition === "left") payload.position = "left"
    else payload.position = "right"
    this.barPosition = payload.position
    if (rawNativeAction === "dismiss") payload.action = "dismiss"
    else if (rawNativeAction === "share") payload.action = "share"
    else payload.action = "link"
    if (payload.action === "share") {
      const shareUrl = el.bridgeAttribute("share-url")
      const shareText = el.bridgeAttribute("share-text")
      if (shareUrl) payload.shareUrl = shareUrl
      if (shareText) payload.shareText = shareText
    }
    if (hasUnread) payload.hasUnread = true
    const onReply = (payload.action === "dismiss" || payload.action === "share") ? null : () => this.element.click()
    this.send("connect", payload, onReply)
  }

  disconnect() {
    this.send("disconnect", { position: this.barPosition || "right" })
    super.disconnect()
  }
}
